import type { ExportIssue } from './issue';

/**
 * Outcome of reading or writing an export file.
 *
 * The same shape as the configuration's and the keypad feature's `Result`, kept
 * separate on purpose: a refusal here has to carry an export issue, so a file
 * problem can never be reported as a device-definition problem.
 */
export type ExportResult<T> =
  | { readonly ok: true; readonly value: T }
  | { readonly ok: false; readonly issue: ExportIssue };

export const ok = <T>(value: T): ExportResult<T> => ({ ok: true, value });

export const fail = (issue: ExportIssue): ExportResult<never> => ({ ok: false, issue });
